import { render, staticRenderFns } from "./GroupsAddEdit.vue?vue&type=template&id=47c9ce38&"
import script from "./GroupsAddEdit.vue?vue&type=script&lang=js&"
export * from "./GroupsAddEdit.vue?vue&type=script&lang=js&"
import style0 from "./GroupsAddEdit.vue?vue&type=style&index=0&id=47c9ce38&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports